import { createSlice } from "@reduxjs/toolkit";
import { addRevision } from "../addRevision";
import { syncPatchImagesReducer, syncSetDataReducer } from "../sync";

export const syncProperties = ["latitude", "longitude"];

const locationSlice = createSlice({
  name: "location",
  initialState: {
    latitude: null,
    longitude: null,
    revision: 0,
    lastUpdate: 0,
  } as {
    latitude: number | null;
    longitude: number | null;
    revision: number;
    lastUpdate: number;
  },
  reducers: {
    updateLatLong: (state, action) => {
      const { latitude, longitude } = action.payload;
      state.latitude = latitude;
      state.longitude = longitude;

      state.lastUpdate = new Date().getTime();

      addRevision(state);
    },
    syncPatchImages: syncPatchImagesReducer,
    syncSetData: syncSetDataReducer(syncProperties, "user-location"),
  },
});

export const { updateLatLong, syncPatchImages, syncSetData } =
  locationSlice.actions;

export const initialState = locationSlice.getInitialState();

export default locationSlice.reducer;
